import { Inject, Component, Input, Optional, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef } from "@angular/core";
import * as Immutable from 'immutable';
import { HttpClient, HttpParams, HttpRequest, HttpHeaders } from '@angular/common/http';
import { ConfigurationSessionManager } from "../../../configurator/providers/configurationSessionManager";
import { ConfiguratorStore, ConfRouteParams, PopupIdentifiers, ConfPageSessionService } from "../../../configurator/providers";
import { RequestViews, ConfDeleteMessage, ChangeOwnershipMessage, Conf, ContactResponse, ApiResponse } from "../../models";
import { ConfMessageProvider } from "../../../configurator/providers/confMessageProvider";
import { NotificationService, NotificationInfo, NotificationType, PopupService, MessageBoxComponent, MessageBoxConfig, InputViewModel, ValueChangeEventArgs } from "../../../../shared/components";
import { ManagedSubscription } from "../../../../shared/managedSubscription";
import { SummaryPrintComponent } from "../print/summaryPrintComponent";
import { AbstractPopupComponent } from "../../../../shared/components/popup/abstractPopupComponent";
import { ContactFormController } from "./contactFormController";
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { HttpService } from "../../../../../core/shared/providers";
import { ContactRequest } from "./contactRequest";

@Component({
  selector: 'contact-form',
  templateUrl: './contactFormComponent.html',
  providers: [ContactFormController],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContactFormComponent extends AbstractPopupComponent {

  public id = "contact-form";
  public url = 'fagerhult/contact/sendemail';

  public nameView: InputViewModel;
  public emailView: InputViewModel;
  public companyView: InputViewModel;
  public cityView: InputViewModel;
  public phoneCheckedView: InputViewModel;
  public phoneView: InputViewModel;
  public messageView: InputViewModel;

  public showPhone: boolean = true;

  nameErrors: Array<string> = [];
  emailErrors: Array<string> = [];
  companyErrors: Array<string> = [];

  constructor(public controller: ContactFormController, public cdr: ChangeDetectorRef,
    @Inject(HttpClient) public httpClient: HttpClient,
    @Inject(HttpService) public httpService: HttpService,
    public notificationService: NotificationService,
    public confSession: ConfPageSessionService,
    @Optional() public popupService?: PopupService) {
    super(cdr, popupService);
  }

  ngOnInit() {

    this.nameView = this.createView('name', this.strings.Name, 'name', true);
    this.emailView = this.createView('email', this.strings.Email, 'email', true);
    this.companyView = this.createView('company', this.strings.Company, 'organization', true);
    this.cityView = this.createView('city', this.strings.City, 'home');
    this.phoneCheckedView = this.createView('phoneChecked', this.strings.getString('Please contact me by phone'));
    this.phoneView = this.createView('phone', this.strings.Phone, 'phone');
    this.messageView = this.createView('message', this.strings.Message);

    this.phoneCheckedView.value = false;    
    this.enablePhoneIfChecked();

    super.ngOnInit();
  }

  enablePhoneIfChecked() {
    this.showPhone = this.phoneCheckedView.value == 'true';
  }

  okClick(): void {

    if (this.validateAll()) {

      let request: ContactRequest = new ContactRequest();
      request.confSessionId = this.confSession.confSessionId;
      request.configurationId = this.confSession.activeConfigurationId;
      request.name = this.nameView.value;
      request.email = this.emailView.value;
      request.company = this.companyView.value;
      request.city = this.cityView.value;
      request.contactByPhone = this.phoneCheckedView.value;
      request.phoneNumber = this.phoneView.value;
      request.message = this.messageView.value;

      this.controller.sendEmail(request).subscribe((response: ApiResponse) => {

        let data = response.data as ContactResponse;

        if (data.success) {

          this.popup.close();
          this.notificationService.notify(<NotificationInfo>{
            title: this.strings.getString('Success'),
            message: data.messages.get(0),
            type: NotificationType.Success,
            selfClose: false
          });

        }
        else {
          
          this.notificationService.notify(<NotificationInfo>{
            title: this.strings.getString('Error'),
            message: data.messages.get(0),
            type: NotificationType.Error,
            selfClose: false
          });

        }

      });
    }

  }

  validateAll(): boolean {

    let nameValid = this.validate(this.nameView.id);
    let emailValid = this.validate(this.emailView.id);
    let companyValid = this.validate(this.companyView.id);

    return nameValid && emailValid && companyValid;
  }

  validate(id: string): boolean {

    switch (id) {

      case 'name':
        {
          this.nameErrors = this.isEmpty(this.nameView) ? this.requiredMessage(this.nameView) : [];
          return this.nameErrors.length == 0;
        }
      case 'email':
        {
          this.emailErrors = this.isEmpty(this.emailView) ? this.requiredMessage(this.companyView) : [];
          return this.emailErrors.length == 0;
        }
      case 'company':
        {
          this.companyErrors = this.isEmpty(this.companyView) ? this.requiredMessage(this.companyView) : [];
          return this.companyErrors.length == 0;
        }
    }
  }

  requiredMessage(view: InputViewModel): Array<string> {
    return [this.strings.getString(`${view.title} is required.`)];
  }

  isEmpty(view: InputViewModel): boolean {
    return !view.value || view.value.trim() == '';
  }


  show(): void {
    this.open();
  }

  createView(id: string, title: string, icon?: string, immediate?: boolean): InputViewModel {

    let view = new InputViewModel(title);
    view.id = id;
    view.icon = icon;
    view.immediate = immediate
    return view;

  }

  valueChange(event: ValueChangeEventArgs): void {
    this.validate(event.actionView.id);

    if (event.actionView.name == this.phoneCheckedView.name)
      this.enablePhoneIfChecked();

  }

  contactByPhone(event: ValueChangeEventArgs): void {
     this.enablePhoneIfChecked();
  }
  
}